module.exports = window.crypto;


//////////////////
// WEBPACK FOOTER
// ./~/randomhex/src/browser.js
// module id = k5D9
// module chunks = 0